import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    if (this.isSafari()) {
      const button = this.buttonTarget;
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
      button.removeAttribute('href');
      button.innerHTML = "Doesn't work on Safari";
    }
  }

  handleRethinkAuth(e) {
    e.preventDefault();
    const url = e.currentTarget.href;

    if (this.isFirefox()) {
      document.requestStorageAccess()
        .then(() => {
          window.open(url, '_top');
        }).catch(() => {
          alert('Unable to proceed because browser storage access was denied. Please enable storage access in your browser settings.');
        });
    } else {
      window.open(url, '_top');
    }
  }

  isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  isFirefox() {
    return navigator.userAgent.toLowerCase().includes('firefox');
  }
}

